module.exports = __webpack_public_path__ + "5a32b699.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_googleplus.png
// module id = 1759
// module chunks = 0